const DEVELOPMENT = 'development';
const BETA = 'beta';
const PRODUCTION = 'prod';

export { DEVELOPMENT, BETA, PRODUCTION };
